/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Page_CtaInputs */

const en_serve_page_cta = /** @type {(inputs: Serve_Page_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have done the steps — open Bystep`)
};

const id_serve_page_cta = /** @type {(inputs: Serve_Page_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah saya lakukan — buka Bystep`)
};

/**
* | output |
* | --- |
* | "I have done the steps — open Bystep" |
*
* @param {Serve_Page_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_page_cta = /** @type {((inputs?: Serve_Page_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Page_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_page_cta(inputs)
	return en_serve_page_cta(inputs)
});